import { AMENITIES } from '@/utils/constants'
import { mapState } from 'vuex'
import { getAmenitiesWithFacets } from '@/utils/filters'
import ozAmenity from './oz-amenity'
import ozIconRemoveFilter from '../../oz-icon-remove-filter'

export default {
  name: 'oz-amenities',

  data () {
    return {
      values: [],
      categories: {},
      titles: [],
    }
  },

  props: {
    filters: { type: Object, required: true },
    isPill: { type: Boolean, default: false },
  },

  watch: {
    'filters.amenities': {
      handler () {
        this.setValues()
      },
    },
    facets () {
      this.categories = getAmenitiesWithFacets(this.facets)
    },
  },

  created () {
    this.setValues()
  },

  mounted () {
    this.categories = getAmenitiesWithFacets(this.facets)
  },

  computed: {
    ...mapState({
      facets: (state) => state.results.facets,
    }),
  },

  methods: {

    setValues () {
      const { amenities } = this.filters
      if (amenities) {
        this.values = amenities
        this.titles = AMENITIES.reduce((acc, curVal) => {
          if (amenities.includes(curVal.id)) acc.push(curVal.text)
          return acc
        }, [])
      }
    },

    onChange () {
      this.$emit('filters:update', { amenities: this.values })
    },

    removeFilter (title) {
      const value = AMENITIES.filter((amenity) => amenity.text === title)[0].id

      this.values = this.values.filter((v) => v !== value)
      this.titles = this.titles.filter((t) => t !== title)
      this.$emit('filters:update', { amenities: this.values }, 'amenities')
    },
  },

  components: {
    ozIconRemoveFilter,
    ozAmenity,
  },
}
